import dynamicTeaserRules from './dynamicTeaserRules';
import infoboxRules from './infoboxRules';
import interviewRules from './interviewRules';
import quoteRules from './quoteRules';
import separatorRules from './separatorRules';

export default [infoboxRules, quoteRules, interviewRules, dynamicTeaserRules, separatorRules];
